import _ from 'lodash'
import React from 'react'
export default {
  getLoadStyles(value){
    value = Number(value)
    return (value >= 80) ? 'ms-danger' : (value >= 60 && value< 80) ? 'ms-warning' : 'ms-success'
  },
  getFormatedDuration (duration) {
    try {
      if (!duration) {
        return '00:00:00.000'
      }
      let date = new Date(duration).getTime()
      let string_time = _.last(new Date(date).toISOString().replace('Z', '').split('T'))
      return string_time
    } catch (err) {
      console.error('getFomatedDuration Error-> ', err.message)
    }
  },
  isOnline(lastNotificationTime) {
    try {
      let deltaTime = Number(5 * 60 * 1000)
      let onlineTime = new Date().getTime() - deltaTime
      return (lastNotificationTime >= onlineTime)
    } catch (error) {
      console.error(`isOnline ${error.message}`)
    }
  },
  getOnlineStyle(lastNotificationTime) {
    try {
      let styleOnlie = (this.isOnline(lastNotificationTime)) ? 'circle-arrow-up online' : 'circle-arrow-down offline'
      return <span className={`glyphicon glyphicon-${styleOnlie}`} aria-hidden="true"></span>
    } catch (error) {
      console.error(`getOnlineStyle ${error.message}`)
    }
  },
  getArrowOnlineStyle(lastNotificationTime) {
    try {
      let styleOnlie = (this.isOnline(lastNotificationTime)) ? 'ok' : 'alert'
      return <span className={`glyphicon glyphicon-${styleOnlie} badget-text status-arrow`} aria-hidden="true"></span>
    } catch (error) {
      console.error(`getOnlineStyle ${error.message}`)
    }
  },
  getOnlineBadgetStyle(lastNotificationTime) {
    try {
      let styleOnlie = (this.isOnline(lastNotificationTime)) ? 'ms-success' : 'ms-danger'
      return styleOnlie
     // return <span className={`glyphicon glyphicon-${styleOnlie}`} aria-hidden="true"></span>
    } catch (error) {
      console.error(`getOnlineStyle ${error.message}`)
    }
  },
  getPollingStyles (status) {
    try {
      return (status === 'POLLING')  ? 'ms-success' : 'ms-danger'
    } catch (error) {
      console.error(`getPollingStyles ${error.message}`)
    }
  },
  getRedisStyles (status) {
    try {
      return (status === 'OK')  ? 'ms-success' : 'ms-danger'
    } catch (error) {
      console.error(`getRedisStyles ${error.message}`)
    }
  },
  getCollapseArrow (isCollapse, padding='', position='right') {
    try {
      let shape = (isCollapse) ? 'triangle-bottom' : 'triangle-right'
      return <span className={`pull-${position} glyphicon glyphicon-${shape} ${padding}`} aria-hidden="true"></span>
    } catch (error) {
      console.error(`getcCllapseArrow ${error.message}`)
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/utils.js